module.exports = {
  name: 'CTA',
  context: {
    class: 'standard',
    video: {
      image: {
        src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/cooking.jpg?mtime=20210623075136&focal=none',
        alt: 'image'
      },
      video: {
        hash: 'axbg48fg0',
        title: 'YouTube Video Title',
        url: 'https://www.youtube.com/watch?v=Nep1qytq9JM'
      }
    },
    heading: {
      text: 'Join Us',
      tag: 'h2',
      class: 'heading-4'
    },
    shortDescription: {
      text: 'Help us build a world where everyone can belong',
      tag: 'p',
      class: 'heading-2'
    },
    button: {
      text: 'Donate',
      url: 'https://google.com',
      class: 'secondary is-hidden-mobile'
    }
  },
  variants: [
    {
      name: 'CTA No Media',
      context: {
        class: 'no-media',
        heading: {
          text: 'Join Us',
          tag: 'h2',
          class: 'heading-4'
        },
        shortDescription: {
          text: 'Explore job opportunities with purpose at Adjoin',
          tag: 'p',
          class: 'heading-2'
        },
        button: {
          text: 'Donate',
          url: 'https://google.com',
          class: 'secondary'
        }
      }
    }
  ]
}
